import React from "react";
import key_map_img from "../../../../assets/images/keyless-return/map-guerin-shadow.svg";

export function VehicleLocation({username, t}) {
  return (<div
    style={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      padding: "2rem",
    }}
  >
    <img
      src={key_map_img}
      alt="Key Dropoff"
      style={{
        maxWidth: "100%", marginBottom: "3rem",
      }}
    />

    <p style={{color: "#94C662", fontSize: "1.6rem", fontWeight: "600", marginTop: "3rem"}}>
      {t("keylessReturnHello", {username})}
    </p>

    <p style={{fontSize: "1.4rem"}}>
      {t("keylessReturnAtStation")}
    </p>
  </div>)
}
